<template>
	<div class="cookie-consent-fallback-message">
		<p>{{ this.$t('cookies_content_hidden_message') }} {{ this.$t('cookies_to_see_the_content') }} <a href="#" @click.stop.prevent="updateConsentPreferences">{{ this.$t('cookies_update_selections_link') }}</a> <span v-if="type==='video' && typeof externalUrl !== 'undefined'"> {{ this.$t('or') }} </span> <a v-if="type==='video' && typeof externalUrl !== 'undefined'" :href="externalUrl">{{ this.$t('cookies_watch_video_link').replace('%s', externalSite) }}</a>.</p>
	</div>
</template>

<script>
import { ConsentVideo } from 'DcVueCookiebot/mixins/ConsentVideo.js'
export default {
	props: ['type', 'externalSite', 'externalUrl'],
	mixins: [ConsentVideo],
}
</script>